import { SHA1 } from 'crypto-js'

export const CHANGE_MAIN = 'CHANGE_MAIN'
export const INVALIDATE_ENDPOINT = 'INVALIDATE_ENDPOINT'
export const RECEIVE_ENDPOINT = 'RECEIVE_ENDPOINT'
export const REQUEST_ENDPOINT = 'REQUEST_ENDPOINT'
export const EDIT_FORM = 'EDIT_FORM'
export const CHANGE_AUTH = 'CHANGE_AUTH'
//FOR PROD
//export const REST_API = 'https://eym-api.traemand.io/api/v1'
//FOR UAT
export const REST_API = process.env.REACT_APP_EYMIO_BASE_URL
export const REACT_APP_EMAIL = process.env.REACT_APP_EMAIL
export const REACT_APP_TEMP = process.env.REACT_APP_PW
//export const REST_API ='http://dev-api.excelym.com/api/v1'
//FOR LOCAL
//export const REST_API = 'http://ec2-52-88-75-115.us-west-2.compute.amazonaws.com:8080/api/v1'
export const EYM_TKN = SHA1('eymio_access_token')
export const EYM_TKN_OBJ = SHA1('eymio_token_object')
export const EYM_USR = SHA1('eymio_user')
export const EYM_ERR = 'eymio_login_error'
export const EDIT_ENDPOINT_LIST = 'EDIT_ENDPOINT_LIST'
export const ADD_KEY_VALUE = 'ADD_KEY_VALUE'
export const SET_LIST_COUNT = 'SET_LIST_COUNT'
export const SET_CURRENT_LIST_PAGE = 'SET_CURRENT_LIST_PAGE'
export const PAGE_BUTTON_ID = 'eymio-pagination-btn-'
export const SET_FILTER = 'SET_FILTER'
export const SET_ITEMS_PER_PAGE = 'SET_ITEMS_PER_PAGE'
export const SHOW_MESSAGE = 'SHOW_MESSAGE'
export const CLOSE_MESSAGE = 'SHOW_MESSAGE'

export const UPDATE_DATE = 'Update Date'
export const CHECK_EXTRACTOPT = 'CHECK_EXTRACT_OPTION'
export const CHECK_PUBLISHOPT = 'CHECK_PUBLISH_OPTION'

export const GET_METHOD = "GET_METHOD"
export const POST_METHOD = "POST_METHOD"
export const PATCH_METHOD = "PATCH_METHOD"
export const DELETE_METHOD = "DELETE_METHOD"
export const REACT_APP_VERSION = process.env.REACT_APP_VERSION
export const REACT_API_VERSION_URL = process.env.REACT_APP_API_VERSION_URL
export const REACT_SVC_VERSION_URL = process.env.REACT_APP_SVC_VERSION_URL

export const DELETE_ME = 'delete me'



// WEBPACK FOOTER //
// ./src/actions/constants.js